import React from 'react';
import { Select } from 'antd';
import { getQueryParam } from '../../utils'

import '../../components/Charts/index.scss'

const urlOrigin = window.location.origin
const handleChange = (value) => {
  localStorage.clear();
  sessionStorage.clear();
  window.location.href = `${urlOrigin}/?chain=${value}`;
};

const chainName = getQueryParam('chain') || 'arbitrum'

const SelectChain = () => (
  
  <div className="select-chain">
    <Select
      defaultValue={chainName}
      style={{ width: 120 }}
      onChange={handleChange}
      options={[
        { value: 'arbitrum', label: 'Arbitrum' },
        { value: 'base', label: 'Base' },
      ]}
    />
  </div>
);

export default SelectChain;
